import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import './styles/Information.scss';

interface Props {
  detail?: any,
  phone?: string
  paciDetail?: any
}

const Information: React.FC<Props> = memo((props) => {
  const {
    detail: {
      fullName, civilId, email,
    }, phone,
    paciDetail,
  } = props;
  return (
    <div className="informationApp">
      <h3>
        <p>
          {fullName ? `${fullName}` : 'undefined'}
        </p>
        <small>{civilId || ''}</small>
        <small style={{ display: 'block', marginTop: '6px', fontSize: '14px' }}>
          {'Validation by PACI: '}
          <strong>{paciDetail?.getInfoSuccess ? 'Yes' : 'No'}</strong>
          {paciDetail?.getInfoSuccess && paciDetail?.updateDate ? ` (${moment.unix(paciDetail.updateDate).tz('Asia/Kuwait').format('DD MMM YYYY, HH:mm:ss')} KWT)` : ''}
        </small>
      </h3>
      <aside>
        <b>{phone}</b>
        <p>
          <FormattedMessage id="dashboard.updateApp.modile" />
        </p>
      </aside>
      <aside>
        <b>{email || ''}</b>
        <p>
          <FormattedMessage id="dashboard.updateApp.emailAddress" />
        </p>
      </aside>
    </div>
  );
});

export default Information;
